export const EWAY_RECURRING_PAYMENT = 'RECURRING';

export const EWAY_ONE_OFF_PAYMENT = 'ONE_OFF';

export const ACTIVE = 1;

export const DISABLE = 2;

export const PRODUCT_CODE_TO_FULL_NAME = {
  DO: 'DynamicOdds',
  DF: 'DyanmicForm',
};

export const PRODUCT_NAME = {
  DYNAMIC_ODDS: 'DynamicOdds',
  DYNAMIC_FORM: 'DynamicForm',
};

export const PRODUCT_CODE = {
  DO: 'DO',
  DF: 'DF',
};

export const DEFAULT_DATE = '0001-01-01T00:00:00Z';

export const PAYMENT_TYPES = [
  { value: 'creditcard', label: 'Credit Card' },
  { value: 'invoiced', label: 'Invoiced' },
  { value: 'complimentary', label: 'Complimentary' },
  { value: 'staff', label: 'Staff' },
  { value: 'PP', label: 'PayPal' },
];

export const CREDITCARD_PAYMENT_TYPE_VALUE = 'creditcard';
